import { Body, ContainerLogo, ContainerMain, Header } from './style';
import { LogoIcon } from '../../assets';
import { ButtonForm, ProgressSteps } from '../../components';
import { Step1Props } from './types';

export default function Step1(props: Step1Props) {
  const { onClick, step } = props;
  return (
    <ContainerMain>
      <ContainerLogo>
        <img src={LogoIcon} alt="logo" />
      </ContainerLogo>
      <Header>
        <div className="info">
          <p>Sua Moto Nova Sem Entrada - Não importa se é negativado</p>
          <span>
            Aprovação em minutos, mesmo para negativados. Sem entrada e zero
            complicações
          </span>
        </div>
        <div className="progress">
          <ProgressSteps currentStep={step} totalSteps={2} />
          <h1>Qual é a faixa de preço da moto que você deseja comprar?</h1>
        </div>
      </Header>
      <Body>
        <ButtonForm
          title="Até R$ 15.000"
          isOutlined
          onClick={onClick}
        />
        <ButtonForm
          title="R$ 15.000 a R$ 20.000"
          isOutlined
          onClick={onClick}
        />
        <ButtonForm
          title="R$ 20.000 a R$ 30.000"
          isOutlined
          onClick={onClick}
        />
        <ButtonForm title="Acima de R$ 30.000" isOutlined onClick={onClick} />
      </Body>
    </ContainerMain>
  );
}
